import { MenuItem, Stack, TextField, Typography } from "@mui/material";

import { startingLookFor, type SlotLook, type SlotMode } from "../../../../render/materials/slotLook";
import { ORIGINAL_LOOK } from "../../../../render/renderConstants";
import type { ModelLook } from "../../../model/modelLook";
import { PanelSection } from "../PanelSection/PanelSection";
import { GlowControls } from "./GlowControls/GlowControls";
import { MODE_LABELS } from "../../../viewerConstants";

interface MaterialControlsProps {
  slots: string[];
  look: ModelLook;
  onLookChange: (look: ModelLook) => void;
}

export function MaterialControls({ slots, look, onLookChange }: MaterialControlsProps) {
  const updateSlot = (slot: string, slotLook: SlotLook) =>
    onLookChange({ ...look, materials: { ...look.materials, [slot]: slotLook } });

  return (
    <PanelSection title="Materials">
      {slots.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No materials.
        </Typography>
      )}
      {slots.map((slot) => {
        const slotLook = look.materials[slot] ?? ORIGINAL_LOOK;
        return (
          <Stack key={slot} spacing={1.5}>
            <TextField
              select
              size="small"
              label={slot}
              value={slotLook.mode}
              onChange={(event) => updateSlot(slot, startingLookFor(event.target.value as SlotMode))}
            >
              {Object.entries(MODE_LABELS).map(([mode, label]) => (
                <MenuItem key={mode} value={mode}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
            {slotLook.mode !== "original" && (
              <GlowControls slotLook={slotLook} onChange={(next) => updateSlot(slot, next)} />
            )}
          </Stack>
        );
      })}
    </PanelSection>
  );
}
